import { playLottie } from "./playLottie";

// Useful when loop is set to true, to stop the looping and wait for other animations to complete;
export function playLottieOnce(obj, segments = []) {
  return playLottie(obj, segments).then(data => {
    data.anim.goToAndStop(segments[1], true);
    return Promise.resolve(data);
  });
}
